import React, { useEffect, useState } from 'react'
import correlativoInternoSrc from './correlativoInternoSrc'
import { message } from 'antd'
import GeneralTable from '../../../../../components/Table'
import LoadMoreButton from '../../../../../components/LoadMoreButton'
import Utils from '../../../../../utils/Utils'
import CorrelativoInternoDrawe from './correlativoInternoDrawe'

export const CorrelativoInterno = () => {

    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [dataSource, setDataSource] = useState([])
    const [nextPage, setNextPage] = useState('')
    const [existMoreInfo, setExistMoreInfo] = useState(false)
    const [editDataDrawer, setEditDataDrawer] = useState(null)
    const [editMode, setEditMode] = useState(false)

    useEffect(() => {
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])

      const loadData = () => {
        setLoading(true)
        setVisible(false)
        correlativoInternoSrc
          .getCorrelativoIType('', 5, true, 'desc')
          .then(result => {
            
            setDataSource(getCorrelativoIType(result))
            setNextPage(result.data.next_page_url)
            setExistMoreInfo(result.data.next_page_url !== null)
            setLoading(false)
          })
          .catch(err => {
            console.log(err)
            message.error('No se ha podido cargar la información')
          })
      }

      const getCorrelativoIType = dataSrc => {
        if (dataSrc !== 'Too Many Attempts.') {
          let _dataSrc = dataSrc.data.data || []
          return _dataSrc.map((d, i) => ({
            key: i,
            id: d.id,
            name: d.store.name || 'Sin nombre', // Valor por defecto si 'name' es null
            initial_correlative: d.initial_correlative || 'N/A', // Valor por defecto si 'initial_correlative' es null
            correlative_number: d.correlative_number || 'N/A', // Valor por defecto si 'correlative_number' es null
          }))
        } else {
          message.error('Se excedió el límite de peticiones, espera y recarga la aplicación')
        }
      }

      const moreInfo = () => {
        if (existMoreInfo) {
          setLoading(true)
          Utils.getNextPage(nextPage)
            .then(response => {
              setDataSource(dataSource.concat(getCorrelativoIType(response)))
              setNextPage(response.data.next_page_url)
              setExistMoreInfo(response.data.next_page_url !== null)
              setLoading(false)
            })
            .catch(err => {
              console.log(err)
              message.error('No se ha podido cargar la información')
            })
        }
      }

      const onSaveButton = (method, data, flagId) => {
        switch (method) {
          case true:
            correlativoInternoSrc
              .editCorrelativoIType(flagId, data)
              .then(res => {
                if (res.errors && Object.keys(res.errors)?.length > 0) {
                  Utils.checkErrors(res)
                } else {
                  message.success('Información actualizada.')
                  loadData()
                }
              })
              .catch(e => {
                console.log(e)
                message.error('Error al actualizar la información.')
              })
            break
          case false:
            correlativoInternoSrc
              .newCorrelativoIType(data)
              .then(res => {
                if (res.errors && Object.keys(res.errors)?.length > 0) {
                  Utils.checkErrors(res)
                } else {
                  message.success('Información actualizada.')
                  loadData()
                }
              })
              .catch(e => {
                console.log(e)
                message.error('Error al crear la información.')
              })
            break
          default:
            break
        }
      }

      const DeleteRow = data => {
        setLoading(true)
        correlativoInternoSrc
          .removeCorrelativoIType(data.id)
          .then(res => {
            if (res.errors && Object.keys(res.errors)?.length > 0) {
              Utils.checkErrors(res)
              setLoading(false)
            } else {
              message.success(`${res.name} se ha elminado.`)
              loadData()
            }
          })
          .catch(e => {
            console.log(e)
            message.error('Error al eliminar elemento.')
          })
      }

      
    const EditRow = data => {
        setEditMode(true)
        setVisible(true)
        setEditDataDrawer(data)
    }
    
      const columns = [
        {
          title: 'Nombre',
          dataIndex: 'name',
          key: 'name',
          render: text => <span>{text}</span>,
        },
        {
            title: 'Correlativo Inicial',
            dataIndex: 'initial_correlative',
            key: 'initial_correlative',
            render: text => <span>{text}</span>,
          },
          {
            title: 'Correlativo Utilizado',
            dataIndex: 'correlative_number',
            key: 'correlative_number',
            render: text => <span>{text}</span>,
          },
      ]

      const onClose = () => {
        setVisible(false)
      }

      const searchText = value => {
        setLoading(true)
        const excludeChars = Utils.excludedCharsContent(value)
        correlativoInternoSrc
          .getCorrelativoIType(value, 5, excludeChars, 'desc')
          .then(result => {
            setDataSource(getCorrelativoIType(result))
            setNextPage(result.data.next_page_url)
            setExistMoreInfo(result.data.next_page_url !== null)
            setLoading(false)
          })
          .catch(err => {
            console.log(err)
            message.error('No se ha podido filtrar la información')
          })
      }
    
    const handlerShowDrawer = () => {
        setVisible(true)
        setEditMode(false)
    }

    
    return (
    <>
        <GeneralTable
        columns={columns}
        dataSource={dataSource}
        handlerTextSearch={searchText}
        handlerEditRow={EditRow}
        handlerDeleteRow={DeleteRow}
        handlerShowDrawer={handlerShowDrawer}
        loading={loading}
        createPermissions={66}
        editPermissions={67}
        deletePermissions={68}
        />
        <LoadMoreButton handlerButton={moreInfo} moreInfo={existMoreInfo} />
        <CorrelativoInternoDrawe
        closable={onClose}
        visible={visible}
        edit={editMode}
        editData={editDataDrawer}
        cancelButton={onClose}
        saveButton={onSaveButton}
        />
    </>
    )
}
